export const ambience = {
  1: 'login',
  2: 'login/ally',
  3: 'login/mf',
  4: 'login/fmva',
};
